import { getRequest, postRequest, deleteRequest } from "../../utils/axios";

export const getHomesApi = () => getRequest("/homes");

export const getHomeDetailsApi = (home_id) => getRequest("/homes/" + home_id);

export const addHomeApi = (formData) => postRequest("/homes", formData);

export const deleteHomeApi = (home_id) => deleteRequest("/homes/" + home_id);
